module.exports = "../study/imgs/maps/Kanagawa/S8/Agriculture/RiceQ/Kanagawa_RiceQ_MRI_RCP26_Now.png";